<div class="seq-scroll" #scrollBox>
    <div class="seq-edit">
        <div
            class="seq-edit-row"
            *ngFor="let r of rows; let i = index; trackBy: trackByIndex"
        >
            <span class="seq-edit-i">{{ padded(i) }}</span>
            <input
                class="input input-sm"
                type="text"
                [placeholder]="namePlaceholder"
                [value]="r.name || ''"
                (input)="updateName(i, $any($event.target).value)"
            />
            <input
                class="input input-sm"
                type="text"
                [placeholder]="runtimePlaceholder"
                [value]="runtimeText(r.runtimeSecs)"
                (change)="updateRuntime(i, $any($event.target).value)"
            />
            <button
                type="button"
                class="ic-act danger"
                title="Remove sequence"
                (click)="removeRow(i)"
            >
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M18 6L6 18M6 6l12 12" />
                </svg>
            </button>
        </div>
    </div>
</div>
<button
    type="button"
    class="seq-add-btn mt-2"
    style="width: 100%;"
    [disabled]="addDisabled"
    [title]="addDisabled ? 'Name the last sequence before adding another' : 'Add sequence'"
    (click)="addRow()"
>
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round">
        <path d="M12 5v14M5 12h14" />
    </svg>
    Add sequence
</button>
<div class="body-xs seq-add-hint" *ngIf="addDisabled">
    Name sequence {{ padded(rows.length - 1) }} before adding another.
</div>
